module.exports = __webpack_public_path__ + "img/xbox_wireless_controller.c3dcdc3.jpg";